import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-build-upload',
  templateUrl: './product-build-upload.component.html',
  styleUrls: ['./product-build-upload.component.css']
})
export class ProductBuildUploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
